import { apiRequest } from '@/lib/queryClient';

const BACKEND_BASE = (import.meta as any).env.VITE_BACKEND_URL || (import.meta as any).env.VITE_API_URL || 'http://localhost:3041';

function backendUrl(path: string) {
    return `${BACKEND_BASE.replace(/\/$/, '')}${path}`;
}

export async function login(email: string, password: string) {
    const res = await apiRequest('POST', backendUrl('/v1/auth/login'), { email, password });
    const body = await res.json().catch(() => null);
    return body;
}

export async function register(data: { name: string; email: string; password: string; mobile?: string }) {
    const res = await apiRequest('POST', backendUrl('/v1/auth/register'), data);
    const body = await res.json().catch(() => null);
    return body;
}

export async function logout(refreshToken?: string) {
    // backend expects { refreshToken }
    return apiRequest('POST', backendUrl('/v1/auth/logout'), { refreshToken });
}

export async function refreshTokens(refreshToken: string) {
    const res = await apiRequest('POST', backendUrl('/v1/auth/refresh-tokens'), { refreshToken });
    const body = await res.json().catch(() => null);
    return body;
}

export default { login, register, logout, refreshTokens };
